<script>
  export default {
    name: 'VGridformBlock',
    props: {
      block: {
        type: Object,
        default: () => null
      },
      devTools: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        blockName: 'vgf-block-edit',
        blockConfig: {
          header: this.$vuetify.lang.t('$vuetify.gfb.block.editTitle'),
          destroy: true,
          fieldstyle: 'outlined',
          autoFooter: true,
          tabindex: 80,
          actions: ['cancel', 'apply'],
          rows: [
            [
              {
                name: 'name',
                label: this.$vuetify.lang.t('$vuetify.gfb.block.name'),
                maxlength: 100,
                required: true,
                size: 12,
                autofocus: true
              }
            ],
            [
              {
                name: 'description',
                label: this.$vuetify.lang.t('$vuetify.gfb.block.description'),
                type: 'textarea',
                rows: 5,
                maxlength: 500,
                required: true
              }
            ],
            [
              {
                name: 'initials',
                label: this.$vuetify.lang.t('$vuetify.gfb.block.initials'),
                maxlength: 10,
                required: true,
                uppercase: true,
                size: 6
              }
            ],
            [
              {
                name: 'export',
                label: this.$vuetify.lang.t('$vuetify.gfb.block.export'),
                hint: this.$vuetify.lang.t('$vuetify.gfb.block.exportHint'),
                type: 'checkbox',
                size: 12
              }
            ],
            [
              {
                name: 'activate',
                label: this.$vuetify.lang.t('$vuetify.gfb.block.activate'),
                hint: this.$vuetify.lang.t('$vuetify.gfb.block.activateHint'),
                type: 'checkbox',
                size: 12,
                hidden: !this.devTools
              }
            ],
            [
              {
                name: 'weighting',
                hint: this.$vuetify.lang.t('$vuetify.gfb.block.weightingHint'),
                type: 'slider',
                min: 0,
                max: 100,
                step: 1,
                value: 100,
                showInput: true,
                tickLabels: [],
                // tickLabels: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                thumbLabel: true,
                thumbSize: 20,
                size: 12
              }
            ]
            // [
            //   {
            //     name: 'internal',
            //     label: this.$vuetify.lang.t('$vuetify.gfb.block.internal'),
            //     type: 'checkbox',
            //     size: 6
            //   },
            //   {
            //     name: 'noRating',
            //     label: this.$vuetify.lang.t('$vuetify.gfb.block.noRating'),
            //     type: 'checkbox',
            //     size: 6
            //   }
            // ]
          ]
        },
        blockCallbacks: {
          onSubmitAction: this.submit.bind(this),
          onCancelAction: this.cancel.bind(this)
        }
      }
    },

    computed: {
      gf() {
        return this.$gridform[this.blockName]
      }
    },
    watch: {
      block() {
        this.refresh()
      }
    },

    mounted() {
      this._bindKeys()
      this.refresh()
      this.$autofocus()
    },
    beforeDestroy() {
      this._unbindKeys()
    },

    methods: {
      _bindKeys() {
        this.keyHandler = e => {
          if (e.code === 'F4') {
            e.stopImmediatePropagation()
            e.stopPropagation()
            this.submit()
            return false
          }
          if (e.code === 'F10' || e.code === 'Escape') {
            e.preventDefault()
            e.stopImmediatePropagation()
            e.stopPropagation()
            this.cancel()
            return false
          }
        }
        document.addEventListener('keydown', this.keyHandler, true)
      },
      _unbindKeys() {
        document.removeEventListener('keydown', this.keyHandler, true)
      },

      refresh() {
        this.$nextTick(() => {
          if (this.gf) {
            this.gf.reset()
            this.gf.values(this.block)
          }
        })
      },

      submit(block) {
        // remove all underscore at beginning of initials
        // NOTE _ marks automatic fieldlists (ex _HEADER, _FOOTER, _NOTES)
        block.initials = block.initials.replace(/^_+/g, '')
        this.$emit('submit', block)
      },
      cancel() {
        this.$emit('cancel')
      }
    }
  }
</script>

<template>
  <VGridform :name="blockName" :config="blockConfig" :callbacks="blockCallbacks"/>
</template>
